import type { EngineParticipant, EngineResult, GeneratedMatch } from './types';

function matchId(round: number, slot: number): string {
  return `RR-R${round}-S${slot}`;
}

/**
 * Berger tables: классический алгоритм составления туров круговой системы.
 * Если игроков нечётно — добавляется виртуальный "BYE", и матч с ним исключается из результата.
 */
export function generateRoundRobin(participants: EngineParticipant[]): EngineResult {
  if (participants.length < 2) {
    throw new Error('Нужно минимум 2 участника');
  }

  // Добавляем BYE если нечётное число
  const players: (string | null)[] = participants.map((p) => p.id);
  if (players.length % 2 === 1) {
    players.push(null);
  }

  const n = players.length;
  const rounds = n - 1;
  const half = n / 2;

  // Фиксируем позицию 0, остальные ротируем по кругу
  const positions = players.slice();

  const matches: GeneratedMatch[] = [];

  for (let r = 0; r < rounds; r++) {
    let slot = 1;
    for (let i = 0; i < half; i++) {
      const a = positions[i];
      const b = positions[n - 1 - i];
      if (a !== null && b !== null) {
        matches.push({
          id: matchId(r + 1, slot),
          stage: 'GROUP',
          round: r + 1,
          slot,
          playerAId: a,
          playerBId: b,
        });
        slot++;
      }
    }
    // Ротация: позиция 0 фиксирована, остальные сдвигаются (классический круг)
    const last = positions.pop()!;
    positions.splice(1, 0, last);
  }

  return { matches, rounds };
}
